import type { UnparseConfig } from "papaparse";
import type { CsvButtonViewModel } from "../interfaces";

export const CSV_DOWNLOAD_HREF_PREFIX = "data:text/csv;charset=utf-8,";

export const DEFAULT_ARIA_LABEL = "Export CSV";
export const DEFAULT_CONFIG: UnparseConfig = {
    delimiter: ",",
    escapeFormulae: true,
    header: true,
    newline: "\r\n",
    quotes: true,
    quoteChar: `"`,
    skipEmptyLines: true,
};
export const DEFAULT_FILENAME = "fusion-pro-logs.csv";
export const DEFAULT_VIEW_MODEL: CsvButtonViewModel = {
    ariaLabel: DEFAULT_ARIA_LABEL,
    filename: null,
    hrefUrl: null,
    isButtonDisabled: true,
};

